import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { motion } from "framer-motion";
import * as Yup from "yup";
import { useState } from "react";

const axios = require("axios").default;

const RegisterSchema = Yup.object().shape({
  username: Yup.string()
    .min(6, "Username must be above 6 characters")
    .max(25, "Username must be below 25 characters")
    .required("Username is required"),
  email: Yup.string()
    .email("E-Mail entered is not valid")
    .required("E-Mail is required"),
  password: Yup.string()
    .min(6, "Password must be a minimum of 6 characters")
    .max(30, "Password must be under 30 characters")
    .required("Password is required"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

function Register() {
  const navigate = useNavigate();
  const [serverError, setServerError] = useState("");

  return (
    <>
      <div className="flex justify-center">
        <button
          onClick={() => {
            navigate("/login");
          }}
          className="text-3xl text-center font-semibold py-7 text-stone-700"
        >
          flashcards
        </button>
      </div>

      <motion.div
        className="flex border border-slate-300 w-full px-24 border-t-0 border-b-0 sm:flex-col sm:px-10 xsm:px-5 md:flex-col-reverse md:mb-10 md:px-10 lg:px-5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div
          id="left"
          className="border-t border-l border-b border-slate-300 w-6/12 rounded-sm rounded-r-none p-5 px-20 sm:w-full sm:border-r xsm:px-10 xxsm:px-5 md:border-r md:w-full lg:px-10"
        >
          <h2 className="text-2xl font-semibold mb-2 text-stone-700">
            Registration
          </h2>
          <Formik
            initialValues={{
              username: "",
              email: "",
              password: "",
              confirmPassword: "",
            }}
            validationSchema={RegisterSchema}
            onSubmit={(values) => {
              console.log(values);
              axios
                .post(
                  "https://application-flashcards.herokuapp.com/api/users/register",
                  {
                    ...values,
                  }
                )
                .then(function (response) {
                  navigate("/login");
                })
                .catch(function (error) {
                  console.log(error);
                  console.log(error.response.data.message);
                  setServerError(error.response.data.message);
                });
            }}
          >
            {({ errors, touched }) => (
              <Form className="flex flex-col h-full">
                <div className="flex flex-col mb-1">
                  <div className="flex justify-between">
                    <label for="username" className="my-2">
                      Username:
                    </label>
                    {errors.username && touched.username ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.username}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    id="username"
                    placeholder=" Enter Username Here"
                    type="text"
                    name="username"
                    className="border border-slate-400 py-1"
                  />
                </div>
                <div className="flex flex-col mb-1">
                  <div className="flex justify-between">
                    <label for="email" className="my-2">
                      E-Mail:
                    </label>
                    {errors.email && touched.email ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.email}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    id="email"
                    placeholder=" Enter E-Mail Here"
                    type="text"
                    name="email"
                    className="border border-slate-400 py-1"
                  />
                </div>
                <div className="flex flex-col mb-1">
                  <div className="flex justify-between">
                    <label for="password" className="my-2">
                      Password:
                    </label>
                    {errors.password && touched.password ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.password}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    id="password"
                    placeholder=" Enter Password Here"
                    type="password"
                    name="password"
                    className="border border-slate-400 py-1"
                  />
                </div>

                <div className="flex flex-col mb-1">
                  <div className="flex justify-between">
                    <label for="confirmpassword" className="my-2">
                      Confirm Password:
                    </label>
                    {errors.confirmPassword && touched.confirmPassword ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.confirmPassword}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    placeholder=" Confirm Password Here"
                    id="confirmpassword"
                    type="password"
                    name="confirmPassword"
                    className="border border-slate-400 py-1"
                  />
                </div>

                {serverError ? (
                  <p className="text-red-500 font-light text-center">
                    Server Error: {serverError}
                  </p>
                ) : null}

                <button
                  className="bg-gradient-to-r from-red-400 to-blue-400 rounded-sm text-white text-xl py-2 mt-4 hover:font-semibold"
                  type="submit"
                >
                  Submit
                </button>
                <div className="flex items-center justify-center mt-7 pb-4">
                  <p className="text-lg text-stone-700">
                    Already have an account?
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();

                      navigate("/login");
                    }}
                    className="text-lg border border-2 border-blue-200 px-6 py-1 mx-4 font-small rounded-sm text-blue-500 hover:border-blue-300 hover:text-blue-600"
                  >
                    Login
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div
          id="right"
          className="border border-slate-300 w-6/12 rounded-sm rounded-l-none bg-gradient-to-r from-red-400 to-blue-400 pt-32 sm:hidden md:w-full md:pb-32 md:mb-4"
        >
          <p className="text-4xl font-light text-center text-white my-2">
            flashcards
          </p>
          <hr className="w-4/12 mx-auto" />
          <p className="text-xl font-thin text-center text-white my-1 mx-32 md:mx-20 lg:mx-10 2xl:mx-5">
            Virtual flashcards for when you don't have any.{" "}
            <span className="font-semibold">flashcards</span> helps you study
            the same way having flashcards would, except it's all virtual.
            Create as many flashcards as you need for as many tests that are
            coming up.
          </p>
        </div>
      </motion.div>
    </>
  );
}

export default Register;
